// import AppNavbar from "../../Navbar/AppNavbar"
import AppLayout from "../../Navbar/AppLayout";
import Footer from "../../Navbar/Footer";
import '../../../assets/css/search.scss'
import '../../../assets/css/viewedContacts.scss'
import { useRef, useState, useEffect } from "react";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useDispatch, useSelector } from "react-redux";
import { downloadViewedContactsDatas, loadTrashedData, loadViewedContactsData } from "../../redux/action";
import { Circles } from "react-loader-spinner";
import TrashTable from "./TrashTable";
import '../../../assets/css/settings.scss'

const Trash = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;

    const { trashedData } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);

    const [tableHeight, setTableHeight] = useState(0);

    const [loading, setLoading] = useState(false);
    const rowsPerPage = 20;
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const [selectedRowsData, setSelectedRowsData] = useState([]); // array of full selected row objects
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {
        fetchTashedData();
    }, [page]); // 👈 Runs whenever `page` changes

    const fetchTashedData = () => {
        dispatch(loadTrashedData(signInID, sbnID, 'Default', role, page, rowsPerPage, setLoading));
    }

    const divRef = useRef(null);
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);
    const [height1, setHeight1] = useState(0);
    const [height2, setHeight2] = useState(0);
    
    useEffect(() => {
        if (div1Ref.current) {
            setHeight1(div1Ref.current.offsetHeight); 
        }
        if (div2Ref.current) {
            setHeight2(div2Ref.current.offsetHeight); 
        }
    }, []);

    useEffect(() => {
        if (!divRef.current) return;

        const parentHeight = divRef.current.offsetHeight;

        const pixelAdjustment = height1 + height2 + 40;

        const tablePxHeight = parentHeight - pixelAdjustment;

        setTableHeight(tablePxHeight);
    }, [height1, height2]);

    return (
        <div className="page-layout" style={{ position: "relative" }}>
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="viewed-contacts-container" ref={divRef} style={{ height: '100%' }}>
                    <div className="viewed-contacts-div">
                        <div className="viewed-contacts-header" ref={div1Ref}>
                            <p>Data</p>
                            <div className="viewed-contacts-view-img-div">
                                <h5 className="m-0">Trash</h5>
                                <i className="fa-solid fa-trash"></i>
                            </div>
                        </div>
                        <TrashTable
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            totalDataCount={totalDataCount}
                            loading={loading}
                            fetchTashedData={fetchTashedData}
                            loadingMore={loadingMore}
                            setLoadingMore={setLoadingMore}
                            tableHeight={tableHeight}
                            selectedRowsData={selectedRowsData}
                            setSelectedRowsData={setSelectedRowsData}
                            trashedData={trashedData}
                            div2Ref={div2Ref}
                            // handleDownload={handleDownload}
                            signInID={signInID}
                            sbnID={sbnID}
                            role={role}
                        />
                    </div>
                </div>
            </div>
            </AppLayout>
            {downloading && (
                <div className="download-overlay">
                    <div className="download-loader-content">
                        <Circles
                            height="30"
                            width="30"
                            color="#007bff"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                        <span className="ms-2">Downloading, please wait...</span>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    )
}

export default Trash;